import React from "react";
import { useTranslation } from "react-i18next";
import { keyframes } from "@emotion/react";
import { Box, Stack, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";

const fly = keyframes`
  0%, 8% { opacity: 0; transform: translate(0, 0) scale(0.8); }
  18% { opacity: 1; }
  46%, 70% { opacity: 1; transform: translate(148px, -6px) scale(1); }
  100% { opacity: 0; transform: translate(148px, -6px); }
`;

const land = keyframes`
  0%, 40% { opacity: 0; transform: translateY(8px); }
  55%, 82% { opacity: 1; transform: translateY(0); }
  100% { opacity: 0; }
`;

const pulse = keyframes`
  0%, 100% { opacity: 0.45; }
  40%, 70% { opacity: 1; }
`;

const motionSafe = {
  "@media (prefers-reduced-motion: reduce)": { animation: "none" },
};

/** Qué hace un SEARCH: webs a la izquierda, fotos que caen en la carpeta. */
export default function SkillAgentSearchIntro() {
  const { t } = useTranslation();
  const sites = [0, 1, 2];
  const photos = ["#0f766e", "#115e59", "#134e4a"];

  return (
    <Stack
      direction={{ xs: "column", sm: "row" }}
      sx={{
        borderRadius: 2.5,
        overflow: "hidden",
        border: "1px solid",
        borderColor: alpha("#0f766e", 0.28),
        bgcolor: alpha("#0f766e", 0.04),
      }}
    >
      <Box
        aria-hidden
        sx={{
          position: "relative",
          flex: { sm: "0 0 240px" },
          height: 112,
          bgcolor: "#f3f7f6",
          overflow: "hidden",
        }}
      >
        {sites.map((i) => (
          <Box
            key={i}
            sx={{
              position: "absolute",
              left: 14,
              top: 16 + i * 30,
              width: 78,
              height: 22,
              borderRadius: 0.8,
              bgcolor: "#fff",
              border: "1px solid #d5e4e1",
              animation: `${pulse} 4.8s ease-in-out infinite`,
              animationDelay: `${i * 0.35}s`,
              ...motionSafe,
            }}
          >
            <Box
              sx={{
                mt: 0.7,
                ml: 0.7,
                width: 34,
                height: 5,
                borderRadius: 1,
                bgcolor: "#0f766e",
                opacity: 0.8,
              }}
            />
          </Box>
        ))}
        <Box
          sx={{
            position: "absolute",
            left: 36,
            top: 42,
            width: 16,
            height: 20,
            borderRadius: 0.4,
            bgcolor: "#0f766e",
            animation: `${fly} 4.8s ease-in-out infinite`,
            ...motionSafe,
          }}
        />
        <Box
          sx={{
            position: "absolute",
            right: 16,
            top: 18,
            width: 86,
            height: 76,
            borderRadius: 1,
            bgcolor: "#fff",
            border: "1px solid #d5e4e1",
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: "4px",
            p: "6px",
          }}
        >
          {photos.map((color, i) => (
            <Box
              key={color}
              sx={{
                borderRadius: 0.5,
                bgcolor: color,
                animation: `${land} 4.8s ease-in-out infinite`,
                animationDelay: `${0.15 + i * 0.18}s`,
                ...motionSafe,
              }}
            />
          ))}
          <Box sx={{ borderRadius: 0.5, bgcolor: "#e7f3f1" }} />
        </Box>
      </Box>
      <Box sx={{ p: 1.5, display: "flex", alignItems: "center" }}>
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ lineHeight: 1.5 }}
        >
          {t("skillAgent.dialog.newSearchLead")}
        </Typography>
      </Box>
    </Stack>
  );
}
